import secondaryButtonColorBorderTextRule from '../../../../../common/algorithms/secondary-button-color-border-text-rule';

const light = (params) => secondaryButtonColorBorderTextRule(params);

export default light;
